import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from 'src/contexts/LocaleContext';
import LandingMark from 'src/components/layout/LandingMark';

const FACEBOOK_URL = 'https://www.facebook.com/agilodonto';
const INSTAGRAM_URL = 'https://www.instagram.com/agilodonto/';
const LINKEDIN_URL = 'https://www.linkedin.com/company/agilodonto/';
const asset = (name) => `${process.env.PUBLIC_URL}/landing/${name}`;

const linkClass = 'text-[#4b5563] hover:text-[#7c3aed]';

function SiteFooter() {
  const { t } = useLocale();

  return (
    <footer className="border-t border-[#ede9fe] bg-[#faf8fc] px-5 pb-10 pt-14 sm:px-10 lg:px-20 lg:pt-[60px]">
      <div className="mx-auto max-w-[1120px]">
        <div className="flex flex-col gap-10 sm:flex-row sm:items-start sm:justify-between">
          <div className="max-w-[280px]">
            <LandingMark titleClassName="text-base" />
            <p className="mt-3 text-[13px] leading-snug text-[#4b5563]">
              {t('landing.footerAbout')}
            </p>
          </div>

          <div className="flex gap-16 text-[13px]">
            <div className="flex flex-col gap-3">
              <p className="font-sora font-bold text-[#0f172a]">{t('landing.product')}</p>
              <a href="/#features" className={linkClass}>{t('landing.navFeatures')}</a>
              <a href="/#pricing" className={linkClass}>{t('landing.navPricing')}</a>
              <a href="/blog" className={linkClass}>{t('landing.navBlog')}</a>
              <Link to="/login" className={linkClass}>{t('landing.login')}</Link>
            </div>
            <div className="flex flex-col gap-3">
              <p className="font-sora font-bold text-[#0f172a]">{t('landing.support')}</p>
              <a href="/#contact" className={linkClass}>{t('landing.navContact')}</a>
              <Link to="/termos" className={linkClass}>{t('landing.terms')}</Link>
              <Link to="/privacidade" className={linkClass}>{t('landing.privacy')}</Link>
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-[#ede9fe] pt-8">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs text-[#9ca3af]">{t('landing.rights')}</p>
            <div className="flex items-center gap-4">
              <a
                href={FACEBOOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="inline-flex"
              >
                <img src={asset('facebook.svg')} alt="" width={18} height={18} />
              </a>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="inline-flex"
              >
                <img src={asset('instagram.svg')} alt="" width={18} height={18} />
              </a>
              <a
                href={LINKEDIN_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="inline-flex"
              >
                <img src={asset('linkedin.svg')} alt="" width={18} height={18} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
